
const digest = '9f5bdf3797010aed6e929863d9a45de78d2aedb386d107b29312f265d0001112';
const classes = {"wrapper":"_wrapper_b4fxy_1","title":"_title_b4fxy_8","text":"_text_b4fxy_13"};
const css = `._wrapper_b4fxy_1 {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #eaedf3;
  height: 100%;
  overflow-y: auto;
}
._wrapper_b4fxy_1 ._title_b4fxy_8 {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 10px;
}
._wrapper_b4fxy_1 ._text_b4fxy_13 {
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  